
const passInput = document.querySelector(".pass_input");
const lengthAlert = document.querySelector(".length_alert");
const textAlert = document.querySelector(".text_alert");
const numberAlert = document.querySelector(".number_alert");
passInput.addEventListener('input', validPassword);
let patternLowercase = /[a-z]/;
let patternUppercase = /[A-Z]/;
let patternNumbers = /[\d]/;
let patternSymbols = /[!-/:-@[-`{-~]/;
let qty_password = 8;
function validPassword() {
  if (passInput.value) {
    if (passInput.value.length <= qty_password) {
      lengthAlert.classList.add('pass_input_red');
     
    }
    else{
      lengthAlert.classList.remove('pass_input_red');
      
    }
    if (passInput.value.length >= qty_password) {
      lengthAlert.classList.add('pass_input_green');
      
      $('.length_alert .check').removeClass('d-none');
      
      
    }
    else{
      lengthAlert.classList.remove('pass_input_green');
      $('.length_alert .check').addClass('d-none');
    }
  }
  if((passInput.value.match(patternLowercase)) && (passInput.value.match(patternUppercase))) {
    textAlert.classList.add('pass_input_green'); 
     
    $('.text_alert .check').removeClass('d-none');
  }
  else {
    textAlert.classList.add('pass_input_red');
    textAlert.classList.remove('pass_input_green');
    $('.text_alert .check').addClass('d-none');
  }
  if((passInput.value.match(patternNumbers)) && (passInput.value.match(patternSymbols))) {
    numberAlert.classList.add('pass_input_green');
   
    $('.number_alert .check').removeClass('d-none');
  }
  else {
    numberAlert.classList.add('pass_input_red');
    numberAlert.classList.remove('pass_input_green');
    $('.number_alert .check').addClass('d-none');
  }
}